const SubAbasEntregaCentralizada = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/logistica/centralizada/ficha/${id}/dadosgerais`,
  },
  {
    label: 'Destaques',
    rota: `/daf/logistica/centralizada/ficha/${id}/destaques`,
  },
];

export default SubAbasEntregaCentralizada;
